import { render } from "./index.vue?vue&type=template&id=ddeb3cc6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ddeb3cc6&lang=css"
import "./index.vue?vue&type=style&index=1&id=ddeb3cc6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__